import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AccessibilityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"accessibility"}/>
}
